import { css, html, LitElement } from 'lit'
import { property } from 'lit/decorators.js'
import { safeCustomElement } from '@/utilities/custom-element'
@safeCustomElement('mdc-header-avatar-button')
export class MdcHeaderAvatarButton extends LitElement {
  @property({ type: String, attribute: 'avatar-src' }) avatarSrc = ''
  @property({ type: String, attribute: 'avatar-alt' }) avatarAlt = 'Avatar'

  static styles = css`
		:host {
			display: inline-block;
			font-family: var(--typography-font-family-sans);
		}

		.mdc-header-avatar-button {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 2.5rem;
			height: 2.5rem;
			border-radius: 100%;
			border: 1px solid var(--color-functional-gray-200, #e5e5e5);
			background: var(--color-functional-gray-white, #ffffff);
			cursor: pointer;
			padding: 0;
			overflow: hidden;
			transition: border-color 0.2s ease;
		}

		.mdc-header-avatar-button:hover {
			border-color: var(--color-functional-gray-300, #999999);
		}

		.mdc-header-avatar-button img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	`

  private handleClick() {
    this.dispatchEvent(
      new CustomEvent('click', {
        detail: {},
        bubbles: true,
        composed: true,
      })
    )
  }

  render() {
    return html`
			<button type="button" class="mdc-header-avatar-button" @click=${this.handleClick} aria-label="User menu">
				${this.avatarSrc ? html`<img src=${this.avatarSrc} alt=${this.avatarAlt} />` : ''}
			</button>
		`
  }
}
